<template>
  <div>
    <ion-searchbar
      class="c-searchbar"
      :placeholder="placeholder"
      v-model="search"
      showCancelButton="never"
      showClearButton="never"
      cancelButtonText="Custom Cancel"
      name="diagnosis"
      autocomplete="off"
      autocorrect="off"
    ></ion-searchbar>
    <div v-if="search.length > 1 && search.length < 3">
      Bitte mindestens 3 Buchstaben eingeben.
    </div>
    <ion-list v-else-if="search.length > 2 && filteredSearchlist.length === 0">
      <ion-item button @click="emitSearch()">{{ search }}</ion-item>
    </ion-list>
    <ion-list v-else>
      <ion-item
        v-for="(item, index) in filteredSearchlist"
        :key="index"
        button
        @click="
          $emit('done', {
            value: item.value,
            id: question.id,
            valueId: item.id,
            area: item.area,
            category: item.category,
          })
        "
        >{{ item.value }}</ion-item
      >
    </ion-list>
    <ion-button
      fill="outline"
      expand="block"
      color="dark"
      @click="
        $emit('done', {
          value: question.cancelText || 'Weiß ich nicht',
          id: question.id,
        })
      "
      >{{ question.cancelText || "Weiß ich nicht" }}</ion-button
    >
  </div>
</template>

<script>
import { IonButton, IonSearchbar, IonList, IonItem } from "@ionic/vue";
// let searchlist = [];

export default {
  emits: ["done"],
  components: {
    IonButton,
    IonSearchbar,
    IonList,
    IonItem,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
    selectedCondition: {
      required: false,
      type: Object,
      default: null,
    },
    answersObject: {
      required: false,
      type: Object,
      default: () => {
        return {};
      },
    },
    zahn: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: "",
      placeholder: "",
      searchlist: [],
    };
  },
  methods: {
    emitSearch() {
      const emitValue = {
        value: this.search,
        id: this.question.id,
      };
      if (this.search.toLowerCase().includes("zahn")) {
        if (this.question.search === "facharztrichtungen") {
          emitValue.valueId = "zahn";
        } else {
          emitValue.valueId = "X";
        }
      } else if (this.search.toLowerCase().includes("kiefer")) {
        emitValue.valueId = "kiefer";
      }
      this.$emit("done", emitValue);
    },
  },
  created() {
    let searchtype = "";
    if (this.question.search) {
      searchtype = this.question.search;
      if (searchtype === "facharztrichtungen") {
        this.placeholder = "Arzt/Facharztrichtung suchen";
      } else if (searchtype === "zahnDiagnosen") {
        this.placeholder = "Diagnose suchen";
      }
    } else {
      searchtype = "diagnosen";
      this.placeholder = "Krankheit/Diagnose suchen";
    }
    console.log(searchtype);

    let isToothDiagnosis = false;
    if (
      searchtype === "diagnosen" &&
      this.selectedCondition?.name?.startsWith("tooth") &&
      this.selectedCondition?.value !== "Schmerzen/Beschwerden"
    ) {
      isToothDiagnosis = true;
    }

    import("@/utils/search/" + searchtype + ".js").then((array) => {
      this.searchlist = [...new Set(array.default)];
      // for (let [index, element] of this.searchlist.entries()) {
      for (let index = this.searchlist.length - 1; index >= 0; index--) {
        const element = this.searchlist[index];
        if (typeof element !== "object") {
          this.searchlist[index] = { value: element };
        } else if (element.hasSides) {
          this.searchlist[index] = {
            value: element.value,
            area: element.area.replace("{side}-", ""),
          };
          // this.searchlist[index] = {
          //   value: element.value + " links",
          //   area: element.area.replace("{side}", "left"),
          // };
          // this.searchlist.splice(index, 0, {
          //   value: element.value + " rechts",
          //   area: element.area.replace("{side}", "right"),
          // });
        }

        if (this.searchlist[index].value.toLowerCase().includes("herz")) {
          this.searchlist[index].area = "body-upper-front";
        }

        if (isToothDiagnosis && element.id !== "X" && element.id !== "kiefer") {
          this.searchlist.splice(index, 1);
        }
        // Folie 7 falsch verstanden: evtl. für Zukunft interessant
        // else if (
        //   this.answersObject["be-2"] &&
        //   !this.zahn &&
        //   ["X", "kiefer"].includes(element.id)
        // ) {
        //   this.searchlist.splice(index, 1);
        // }
      }

      this.searchlist.sort((a, b) => {
        if (a.value.toLowerCase() < b.value.toLowerCase()) {
          return -1;
        }
        if (a.value.toLowerCase() > b.value.toLowerCase()) {
          return 1;
        }
        return 0;
      });

      console.log(this.searchlist);
    });
  },
  computed: {
    filteredSearchlist() {
      let result = [];
      let startsWith = [];
      let others = [];
      if (this.search.length > 2) {
        for (const element of this.searchlist) {
          if (
            element.value.toLowerCase().startsWith(this.search.toLowerCase())
          ) {
            startsWith.push(element);
          } else if (
            element.value.toLowerCase().includes(this.search.toLowerCase())
          ) {
            others.push(element);
          }
        }
        result = startsWith.concat(others);
        // startsWith = searchlist.filter((el) => {
        //     return el.toLowerCase().startsWith(this.search.toLowerCase());
        // });
        // others = searchlist.filter((el) => {
        //     return el.toLowerCase().includes(this.search.toLowerCase());
        // });
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
.c-searchbar {
  .searchbar-input {
    font-size: 14px;
    -webkit-padding-end: 10px;
    padding-inline-end: 10px;
  }
}
</style>
